module.exports = __webpack_public_path__ + "static/img/icon-2.261d7b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-5/icon-2.png
// module id = 25na
// module chunks = 0